/**
 * Scroll restoration on back/forward.
 * Lives outside the Lenis block because Lenis is skipped on touch devices for
 * performance - restoration still has to work there. Uses Lenis when it exists,
 * plain window.scrollTo otherwise.
 */
(function () {
  'use strict';
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}

  var KEY = 'meddey:scroll:';
  var lastSavedAt = 0;
  function scrollKey() { return KEY + location.pathname + location.search; }

  /* Captured on link CLICK in the capture phase: by the time 'pagehide' fires,
     something has already scrolled the page near the top, which stored ~107px
     instead of where the shopper actually was. */
  function saveScroll(force) {
    var now = Date.now();
    if (!force && now - lastSavedAt < 1500) return;
    var y = Math.round(window.scrollY || document.documentElement.scrollTop || 0);
    try { sessionStorage.setItem(scrollKey(), String(y)); } catch (e) {}
    lastSavedAt = now;
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (t && t.closest && t.closest('a[href]')) saveScroll(true);
  }, true);
  window.addEventListener('pagehide', function () { saveScroll(false); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') saveScroll(false);
  });

  function restoreScroll() {
    var y = 0;
    try { y = parseInt(sessionStorage.getItem(scrollKey()) || '0', 10) || 0; } catch (e) {}
    if (y <= 0) return;
    var tries = 0;
    (function attempt() {
      var reachable = document.documentElement.scrollHeight - window.innerHeight;
      /* the page grows as images load, so retry until the target is reachable */
      if (reachable >= y || tries > 30) {
        if (window.meddeyLenis) {
          try { window.meddeyLenis.scrollTo(y, { immediate: true, force: true }); return; } catch (e) {}
        }
        window.scrollTo(0, y);
        return;
      }
      tries++;
      setTimeout(attempt, 100);
    })();
  }

  var nav = (performance.getEntriesByType('navigation') || [])[0];
  if (nav && nav.type === 'back_forward') {
    if (document.readyState === 'complete') restoreScroll();
    else window.addEventListener('load', restoreScroll);
  }
  window.addEventListener('pageshow', function (event) { if (event.persisted) restoreScroll(); });
})();

/**
 * ============================================================================
 * MEDDEY ENTERPRISE LENIS SMOOTH SCROLL INTEGRATION
 * Ultra-smooth momentum scrolling powered by Lenis.
 * Fully configurable via Shopify Theme Settings with accessibility motion safeguards.
 * ============================================================================
 */
(function() {
  'use strict';

  // 1. Accessibility Check: Respect reduced motion user preference
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  /* Skip Lenis on touch devices.
     smoothTouch is false, so Lenis smooths nothing on a phone - but its
     requestAnimationFrame loop still runs every frame. Lighthouse measured
     2,923ms of CPU for meddey-lenis.js against only 187ms of script evaluation,
     i.e. almost all of it was the idle rAF loop. Native momentum scrolling on
     touch is already smooth, so there is nothing to lose here. */
  var coarsePointer = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;
  var touchCapable = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  if (coarsePointer || touchCapable) {
    return;
  }

  function initMeddeyLenis() {
    if (typeof window.Lenis === 'undefined') {
      // Retry once after DOM/scripts finish loading if script was deferred
      window.addEventListener('load', function() {
        if (typeof window.Lenis !== 'undefined' && !window.meddeyLenis) {
          initMeddeyLenis();
        }
      });
      return;
    }

    if (window.meddeyLenis) return;

    // 2. Read Configuration from HTML data attributes or global config
    const root = document.documentElement;
    const cfg = window.meddeyLenisConfig || {};

    const isEnabled = cfg.enabled !== undefined ? cfg.enabled : (root.dataset.lenisEnabled !== 'false');
    if (!isEnabled) return;

    // Presets: silky (0.08), balanced (0.10), snappy (0.14)
    const preset = cfg.preset || root.dataset.lenisPreset || 'balanced';
    let defaultLerp = 0.10;
    if (preset === 'silky') defaultLerp = 0.08;
    else if (preset === 'snappy') defaultLerp = 0.14;

    const lerp = parseFloat(cfg.lerp || root.dataset.lenisLerp) || defaultLerp;
    const duration = parseFloat(cfg.duration || root.dataset.lenisDuration) || 1.2;
    const wheelMultiplier = parseFloat(cfg.wheelMultiplier || root.dataset.lenisWheelMultiplier) || 1.0;
    const smoothTouch = (cfg.smoothTouch !== undefined ? cfg.smoothTouch : root.dataset.lenisSmoothTouch === 'true');
    const autoAnchor = (cfg.autoAnchor !== undefined ? cfg.autoAnchor : root.dataset.lenisAutoAnchor !== 'false');

    // 3. Initialize Lenis Instance
    try {
      const lenis = new window.Lenis({
        lerp: lerp,
        duration: duration,
        smoothWheel: true,
        wheelMultiplier: wheelMultiplier,
        touchMultiplier: 1.0,
        smoothTouch: smoothTouch,
        syncTouch: false,
        infinite: false,
        autoResize: true
      });

      window.meddeyLenis = lenis;

      // 4. RequestAnimationFrame Loop
      let rafId;
      function raf(time) {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);






      }
      rafId = requestAnimationFrame(raf);

      // 5. Drawer & Modal Scroll Lock Synchronizer
      const markScrollPrevent = () => {
        // Strictly reserve data-lenis-prevent for true vertical overlay containers
        const preventSelectors = [
          '.drawer',
          '.drawer__content',
          '.cart-drawer',
          '.cart-drawer__content',
          '.mini-cart__content',
          '.modal',
          '.modal__content',
          '.predictive-search',
          '.meddey-suggest__inner',
          '.product-facet__aside-inner',
          // Zecpe checkout renders in the top window, so Lenis was swallowing the
          // wheel over its payment list. Tagging the overlay lets every scroller
          // inside it (payment methods, address list, order summary) scroll natively.
          '#zecpe__backdrop',
          '#zecpe',
          '#zecpe-contents',
          '#zecpe-overlay',
          // Audited 2026-09-22: the rest of the theme's vertical overlay panels.
          // All are overflow-y:auto / overflow:auto inside a fixed or high-z
          // container, so Lenis would swallow the wheel over them just as it did
          // over Zecpe. Horizontal sliders stay out - the block below strips them.
          '.meddey-qv-drawer-content',
          '.meddey-cart-content-scroller',
          '.meddey-cart-preview-body',
          '.popover__content',
          '.nav-dropdown--restrict'
        ];
        document.querySelectorAll(preventSelectors.join(',')).forEach((el) => {
          if (!el.hasAttribute('data-lenis-prevent')) {
            el.setAttribute('data-lenis-prevent', '');
          }
        });

        // Ensure horizontal sliders and their empty track areas NEVER have data-lenis-prevent
        document.querySelectorAll('.meddey-slider, .meddey-slider-track, .meddey-row-slider-track, .meddey-offers-grid, .meddey-swipe, .product-list__inner--scroller, .meddey-row-slider-wrap, .meddey-multi-row-sliders, product-recommendations, .shopify-section--product-recommendations, recently-viewed-products, .shopify-section--recently-viewed-products').forEach((el) => {
          if (el.hasAttribute('data-lenis-prevent')) {
            el.removeAttribute('data-lenis-prevent');
          }
        });
      };
      markScrollPrevent();

      // Check if modal or drawer is active to stop main body momentum
      const checkModalLock = () => {
        const isLocked = document.documentElement.classList.contains('has-active-drawer') ||
                         document.documentElement.classList.contains('is-locked') ||
                         document.body.classList.contains('has-active-drawer') ||
                         document.body.classList.contains('is-locked') ||
                         document.body.classList.contains('modal-open') ||
                         document.querySelector('.drawer[aria-hidden="false"], .modal[aria-hidden="false"], .drawer.is-open');

        if (isLocked) {
          lenis.stop();
        } else {
          lenis.start();
        }
      };

      if (window.MutationObserver) {
        const bodyObs = new MutationObserver(() => {
          checkModalLock();
          markScrollPrevent();
        });
        bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'], childList: true });
        bodyObs.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
      }

      // Listen to theme custom events for drawers/modals
      const lockEvents = ['cart:open', 'drawer:open', 'modal:open', 'quick-view:open'];
      const unlockEvents = ['cart:close', 'drawer:close', 'modal:close', 'quick-view:close'];
      lockEvents.forEach(evt => window.addEventListener(evt, () => lenis.stop()));
      unlockEvents.forEach(evt => window.addEventListener(evt, () => lenis.start()));

      // 6. Smooth Internal Anchor Link Navigation (#)
      if (autoAnchor) {
        document.addEventListener('click', function(e) {
          const anchor = e.target.closest('a[href^="#"]');
          if (!anchor) return;
          const href = anchor.getAttribute('href');
          if (!href || href === '#' || href.length < 2) return;

          const target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            const header = document.querySelector('.header, #shopify-section-header, .header__wrapper');
            const offset = header ? -(header.getBoundingClientRect().height + 16) : -20;
            lenis.scrollTo(target, { offset: offset, duration: 1.2 });
          }
        }, false);
      }

      // 7. Shopify Theme Editor Integration & Resize Handlers
      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:load', () => lenis.resize());
        document.addEventListener('shopify:section:unload', () => lenis.resize());
        document.addEventListener('shopify:section:select', () => lenis.resize());
        document.addEventListener('shopify:section:deselect', () => lenis.resize());
      }

      window.addEventListener('resize', () => lenis.resize(), { passive: true });
      window.addEventListener('orientationchange', () => lenis.resize(), { passive: true });

      /* No cancelAnimationFrame on beforeunload/pagehide: Back restores this page
         from the bfcache with the loop dead, Lenis keeps eating the wheel and the
         page cannot scroll. A real unload stops the loop anyway. */

    } catch (err) {
      console.warn('[Meddey Lenis] Initialization error:', err);
    }
  }

  // Self-execute on DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMeddeyLenis);
  } else {
    initMeddeyLenis();
  }
})();
